import React, { useEffect, useState } from 'react';
import AdminSidebar from './Components/AdminSidebar';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
export const AdminDashboard = () => {
  const [nftData, setNftData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState('');
  const handleClick = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedReason('');
  };
  
  const handleReasonSelect = (reason) => {
    setSelectedReason(reason);
  };
const navigate = useNavigate()

let wAdminLocalGet = localStorage.getItem("wAdminLocal")
  const fetchNFTData = async () => {
    try {
      const response = await fetch('https://mint-blocks-api-production.up.railway.app/api/nftsApprovalRequest');
      const data = await response.json();
      setNftData(data);
    } catch (error) {
      console.log('Error fetching NFT data:', error);
    }
  };

  useEffect(() => {
    fetchNFTData();
  }, []);

  const approveNFT = async (tokenId) => {
    try {
      const response = await fetch(`https://mint-blocks-api-production.up.railway.app/api/nftsApprovalRequest/${tokenId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ isApproved: true }), // Send the updated value
      });
      if (response.ok) {
        // NFT approved successfully
        toast.success('NFT approved successfully!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // You can update the local state or re-fetch the data to reflect the changes
        fetchNFTData();
      } else {
        // Handle error response
        console.error('Failed to approve NFT:', response.statusText);
        toast.error('Failed to approve NFT!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

      }
    } catch (error) {
      console.error('Error approving NFT:', error);
      toast.error('Error approving NFT!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  
  const rejectNFT = async (tokenId) => {
    try {
      const response = await fetch(`https://mint-blocks-api-production.up.railway.app/api/nftsByTokenId/${tokenId}`);
      if (response.ok) {
        const nft = await response.json();
        
        const deleteResponse = await fetch(`https://mint-blocks-api-production.up.railway.app/api/nftsDelTokenId/${tokenId}`, {
          method: 'DELETE',
        });
        setIsModalOpen(false)
        if (deleteResponse.ok) {
          // NFT rejected and deleted successfully
          // You can update the local state or re-fetch the data to reflect the changes
          toast.warn('NFT rejected successfully!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
  
          // Post the NFT details to the Rejected collection
          const rejectedResponse = await axios.post('https://mint-blocks-api-production.up.railway.app/rejected', {
            tokenId: nft.tokenId,
            name: nft.name,
            description: nft.description,
            fileUrl: nft.fileUrl,
            price: nft.price,
            sellerAddress: nft.sellerAddress,
            reason: selectedReason,
          });
  
          if (rejectedResponse.status === 200) {
            console.log('NFT details posted to Rejected collection:', nft);
          } else {
            console.error('Failed to post NFT details to Rejected collection:', rejectedResponse.statusText);
          }
  
          fetchNFTData();
        } else {
          // Handle error response
          console.error('Failed to reject NFT:', deleteResponse.statusText);
          toast.error('Failed to reject NFT!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } else {
        // Handle error response
        console.error('Failed to retrieve NFT:', response.statusText);
        toast.error('Failed to retrieve NFT!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.error('Error rejecting NFT:', error);
      toast.error('Error rejecting NFT!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  
  const NFTCard = (nft) => {
    return (
      <tr key={nft.tokenId}>
        <td>{nft.tokenId}</td>
        <td >
          <img src={nft.fileUrl} alt="" height={40} />{' '}
        </td>
       

        <td>{nft.name}</td>
        <td>{nft.description}</td>
        <td>
          <button type="button" className="btn btn-success mr-2 btn-sm" onClick={() => approveNFT(nft.tokenId)}>
            Approve
          </button>
          {/* <button type="button" className="btn btn-danger btn-sm ms-2" onClick={() => rejectNFT(nft.tokenId)}>
            Reject
          </button> */}
           <button type="button" className="btn btn-danger btn-sm ms-2" onClick={handleClick}>
            Reject
          </button>
          {isModalOpen && (
        <div className="modal">
          <div className="modalContent">
            <h2>Select Reason</h2>
            <ul>
  <li onClick={() => handleReasonSelect('Inappropriate Content')}>Inappropriate Content</li>
  <li onClick={() => handleReasonSelect('Poor Quality')}>Poor Quality</li>
  <li onClick={() => handleReasonSelect('Abusive')}>Abusive</li>
  <li onClick={() => handleReasonSelect('Hurting any religion or community')}>Hurting any religion or community</li>
  <li onClick={() => handleReasonSelect('Unauthorized or Stolen Content')}>Unauthorized or Stolen Content</li>
  <li onClick={() => handleReasonSelect('Violation of Intellectual Property Rights')}>Violation of Intellectual Property Rights</li>
  <li onClick={() => handleReasonSelect('Scams or Fraudulent Activity')}>Scams or Fraudulent Activity</li>
  <li onClick={() => handleReasonSelect('Offensive or Hate Speech')}>Offensive or Hate Speech</li>
  <li onClick={() => handleReasonSelect('Counterfeit or Replica NFTs')}>Counterfeit or Replica NFTs</li>
  <li onClick={() => handleReasonSelect('Prohibited Activities or Illegal Content')}>Prohibited Activities or Illegal Content</li>
  <li onClick={() => handleReasonSelect('Spam or Misleading Content')}>Spam or Misleading Content</li>
 
</ul>

            <p>Selected Reason: {selectedReason}</p>
            <button className="btn btn-outline-danger" onClick={handleClose}>Close</button>
            <button className="btn btn-danger ms-2" onClick={() => rejectNFT(nft.tokenId)}>Reject</button>
          </div>
        </div>
      )}

      {selectedReason && (
        <div>
         
        </div>
      )}

        </td>
      </tr>
    );
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/alogin")
  };
  if(wAdminLocalGet === "LoggedIn"){
  return (
    
    <div className="container admin-dashboard-page">
      <div className="user-main container ms-3">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="">Pending NFTs</h3>
          <button type="button" className="btn btn-primary" onClick={handleLogout}>
            Logout
          </button>
        </div>
        <p>All NFTs pending approval are listed below</p>
        <table className="table">
          <thead>
            <tr className="table-light">
              <th scope="col">Token ID</th>
              <th scope="col">Image</th>
              <th scope="col">Name</th>
              <th scope="col">Description</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>{nftData.map(NFTCard)}</tbody>
        </table>
        <Link to="/alogin">Go to Login</Link>
      </div>
      <ToastContainer position="top-right" />
    </div>
  );}else{
    return(
<>Admin Not LoggedIn</>
    )
  }
};
